import axios, { AxiosResponse } from 'axios';

import { SearchApiResponse, SearchWordRequest, SEARCH_API_ERRORS } from '../types/api/SearchApiType';
import { AppDispatch } from '../store/store';
import { setState as setConditions } from '../slice/ConditionsSlice';
import { setState as setSearchResult } from '../slice/SearchResultSlice';

// 検索サジェスト API-3001
const searchList = async (dispatch: AppDispatch) => {
    try {
        const result: AxiosResponse<SearchApiResponse> = await axios.get('/api/search/list');
        if (result.data) {
            // responseをdispatch
            dispatch(setConditions(result.data));
            return '';
        } else {
            return SEARCH_API_ERRORS.REQUEST_ERROR_3001;
        }
    } catch (error) {
        // リクエストが異常終了
        let error_ret = SEARCH_API_ERRORS.REQUEST_ERROR_3001;
        if (axios.isAxiosError(error)) {
            if (error.response?.status) {
                // ステータスコードが設定されていた場合、ステータスコードを設定
                error_ret = SEARCH_API_ERRORS.REQUEST_ERROR_3001_STATUS_CODE.replace(
                    '%1',
                    error.response.status as unknown as string
                );
            }
        }
        return error_ret;
    }
};

// キーワード検索 API-3002
const searchKeyword = async (dispatch: AppDispatch, searchWord?: string) => {
    // postのbody部
    const searchData: SearchWordRequest = {
        query_string: searchWord ?? '',
    };
    try {
        const result: AxiosResponse<SearchApiResponse> = await axios.post('/api/search', searchData);
        if (result.data) {
            // responseをdispatch
            dispatch(setSearchResult(result.data));
            return '';
        } else {
            return SEARCH_API_ERRORS.REQUEST_ERROR_3002;
        }
    } catch (error) {
        // リクエストが異常終了
        let error_ret = SEARCH_API_ERRORS.REQUEST_ERROR_3002;
        if (axios.isAxiosError(error)) {
            if (error.response?.status) {
                // ステータスコードが設定されていた場合、ステータスコードを設定
                error_ret = SEARCH_API_ERRORS.REQUEST_ERROR_3002_STATUS_CODE.replace(
                    '%1',
                    error.response.status as unknown as string
                );
            }
        }
        return error_ret;
    }
};

export const searchApi = {
    searchList,
    searchKeyword,
};
